
              export default {
                mounted() {
                  this.onDocClick = (e) => {
                    if (this.el.hidden) return
                    const trigger = document.getElementById("dashboard-identity-toggle")
                    if (this.el.contains(e.target) || trigger?.contains(e.target)) return
                    this.el.hidden = true
                    trigger?.setAttribute("aria-expanded", "false")
                  }
                  this.onKey = (e) => {
                    if (e.key === "Escape" && !this.el.hidden) {
                      this.el.hidden = true
                      document.getElementById("dashboard-identity-toggle")
                        ?.setAttribute("aria-expanded", "false")
                    }
                  }
                  document.addEventListener("click", this.onDocClick)
                  document.addEventListener("keydown", this.onKey)
                },
                destroyed() {
                  document.removeEventListener("click", this.onDocClick)
                  document.removeEventListener("keydown", this.onKey)
                }
              }
            